import type { GetTemplatesParams } from "../api";

export const templateKeys = {
  all: ["psd-templates"] as const,
  lists: () => [...templateKeys.all, "list"] as const,
  list: (filters?: GetTemplatesParams) => [...templateKeys.lists(), filters] as const,
  details: () => [...templateKeys.all, "detail"] as const,
  detail: (id: string) => [...templateKeys.details(), id] as const,
  categories: () => [...templateKeys.all, "categories"] as const,
};
